export enum TipoIvaAfip {
    Cero = 3,
    DiezPuntoCinco = 4,
    Veintiuno = 5,    
    Veinticiete = 6
}